import { render } from "./TableIncidence_zones.vue?vue&type=template&id=22ad2073&scoped=true"
import script from "./TableIncidence_zones.vue?vue&type=script&lang=js"
export * from "./TableIncidence_zones.vue?vue&type=script&lang=js"

import "./TableIncidence_zones.vue?vue&type=style&index=0&id=22ad2073&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ad2073"]])

export default __exports__